import { ReportsDetails } from '../../services/api.types';
import { DraggableModal, DraggableModalProps } from '../DraggableModal';
import { TeacherReport } from '../TeacherReport';
import { apiService } from '../../services/api';
import { useState } from 'react';
import { ReportInfo } from '../../pages/ListReports';
import { getEndHour } from '../../utils/date';
import { ReportsInfoList } from './ReportsInfoList';

interface ReportsListModalProps extends Omit<DraggableModalProps, 'children'> {
  onClose: () => void;
  reports: ReportsDetails[];
}

export function ReportsListModal({
  onClose,
  reports,
  ...draggableModalProps
}: ReportsListModalProps) {
  const [reportInfo, setReportInfo] = useState<ReportInfo | undefined>();
  const [reportInfoOpen, setReportInfoOpen] = useState<boolean>(false);

  const handleOpenReport = async (reportDetails: ReportsDetails) => {
    if (!reportDetails) return;
    await apiService.findReport(reportDetails.reportId).then((r) => {
      setReportInfo({
        id: r.id,
        classLocation: r.place,
        date: r.date,
        email: reportDetails.teacherEmail,
        startTimeClass: r.startHour,
        endTimeClass: getEndHour(r.startHour, r.duration),
        fullName: reportDetails.teacherName,
        studentName: reportDetails.studentName,
        responsibleFullName: reportDetails.responsibleName,
        generalObservation: r.observations,
        status: r.status,
        studentPerformance: r.studentPerformance,
        taughtContent: r.taughtContent,
        reviewRequest: r.reviewRequest,
        valueFromResponsible: r.valueFromResponsible,
        valueToTeacher: r.valueToTeacher,
        valueToTrip: r.valueToTrip,
        wasStudentAbsent: r.wasStudentAbsent,
      });
      setReportInfoOpen(true);
    });
  };

  return (
    <>
      <DraggableModal {...draggableModalProps} onClose={onClose}>
        <h4>
          Aulas dadas ainda não pagas (que serão cobradas no proximo mês):
        </h4>

        <ReportsInfoList reports={reports} onOpenReport={handleOpenReport} />
      </DraggableModal>

      {reportInfo && (
        <TeacherReport
          title="Relatório"
          reportInfo={reportInfo}
          open={reportInfoOpen}
          onClose={() => {
            setReportInfo(undefined);
            setReportInfoOpen(false);
          }}
        />
      )}
    </>
  );
}
